import { useState, useEffect, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '@/contexts/ThemeContext';

const LOGO = 'https://storage.readdy-site.link/project_files/0f27b860-7899-4d17-a451-e043696e780c/51ae8833-6174-4697-a4e4-f9113fa91181_cargonet_PNG.png?v=3ebb7523aaf49333dc87e7813a9a53fc';



export default function GirisPage() {
  const { isDark } = useTheme();
  const [showPass, setShowPass] = useState(false);
  const [remember, setRemember] = useState(false);
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [vis, setVis] = useState(false);

  useEffect(() => {
    document.title = 'Giriş Yap | CargoNet';
    window.scrollTo(0, 0);
    const t = setTimeout(() => setVis(true), 100);
    return () => clearTimeout(t);
  }, []);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!form.username || !form.password) {
      setError('Lütfen tüm alanları doldurun.');
      return;
    }
    setError('');
    setLoading(true);
    await new Promise((r) => setTimeout(r, 1200));
    setLoading(false);
    setError('Kullanıcı adı veya şifre hatalı.');
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 py-8"
      style={{ background: 'var(--bg)', fontFamily: 'var(--font-b)', paddingTop: 120 }}
    >
      {/* Ambient background */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        <div style={{
          position: 'absolute', top: '-20%', right: '-10%',
          width: 700, height: 700,
          background: 'radial-gradient(circle, rgba(232,97,26,0.13) 0%, transparent 60%)',
          borderRadius: '50%',
        }} />
        <div style={{
          position: 'absolute', bottom: '-15%', left: '-8%',
          width: 500, height: 500,
          background: 'radial-gradient(circle, rgba(232,97,26,0.07) 0%, transparent 60%)',
          borderRadius: '50%',
        }} />
        <div style={{
          position: 'absolute', inset: 0,
          backgroundImage: 'radial-gradient(rgba(255,255,255,0.04) 1px, transparent 1px)',
          backgroundSize: '36px 36px',
        }} />
      </div>

      {/* Main card */}
      <div
        className="relative w-full"
        style={{
          maxWidth: 1000,
          borderRadius: 28,
          overflow: 'hidden',
          display: 'grid',
          gridTemplateColumns: 'minmax(0,1.1fr) minmax(0,0.9fr)',
          border: '1px solid rgba(255,255,255,0.08)',
          opacity: vis ? 1 : 0,
          transform: vis ? 'translateY(0) scale(1)' : 'translateY(28px) scale(0.96)',
          transition: 'all 0.65s cubic-bezier(0.16,1,0.3,1)',
        }}
      >
        {/* ── LEFT PANEL — Hero Image ── */}
        <div
          className="hidden md:flex flex-col justify-between relative overflow-hidden"
          style={{ minHeight: 620 }}
        >
          {/* Background image */}
          <img
            src="https://readdy.ai/api/search-image?query=dramatic%20aerial%20view%20of%20cargo%20airplane%20flying%20over%20golden%20sunset%20clouds%2C%20warm%20orange%20and%20amber%20sky%2C%20silhouette%20of%20aircraft%20with%20contrails%2C%20professional%20commercial%20aviation%20photography%2C%20cinematic%20lighting%2C%20deep%20shadows%20and%20highlights%2C%20moody%20atmospheric%20sky%20with%20dramatic%20clouds%2C%20logistics%20and%20freight%20transportation%20theme%2C%20high%20contrast%20warm%20color%20palette&width=520&height=620&seq=login-hero-3&orientation=portrait"
            alt="CargoNet"
            className="absolute inset-0 w-full h-full object-cover"
            loading="eager"
          />

          {/* Gradient overlays */}
          <div className="absolute inset-0" style={{
            background: 'linear-gradient(180deg, rgba(6,9,18,0.92) 0%, rgba(6,9,18,0.55) 35%, rgba(6,9,18,0.65) 65%, rgba(6,9,18,0.97) 100%)',
          }} />
          <div className="absolute inset-0" style={{
            background: 'linear-gradient(90deg, rgba(232,97,26,0.18) 0%, transparent 60%)',
          }} />

          {/* Logo */}
          <div className="relative z-10 p-10">
            <Link to="/" className="inline-block cursor-pointer">
              <img src={LOGO} alt="CargoNet" className="brightness-0 invert" style={{ height: 36, width: 'auto', objectFit: 'contain' }} />
            </Link>
          </div>

          {/* Center content */}
          <div className="relative z-10 px-10 flex-1 flex flex-col justify-center">
            <div className="label mb-5" style={{ display: 'inline-flex' }}>
              <div className="label-dot" />
              Türkiye&apos;den Dünyaya
            </div>
            <h2 style={{
              fontFamily: 'var(--font-h)', fontWeight: 800,
              fontSize: 'clamp(32px, 3.2vw, 44px)',
              color: '#fff', lineHeight: 1.05, marginBottom: 16,
              textShadow: '0 2px 20px rgba(0,0,0,0.8)',
            }}>
              Küresel Lojistik<br />
              <span style={{
                background: 'linear-gradient(135deg, #E8611A 0%, #FF9A55 100%)',
                WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
              }}>Tek Panelde.</span>
            </h2>
            <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.75)', lineHeight: 1.75, maxWidth: 320, textShadow: '0 1px 12px rgba(0,0,0,0.9)' }}>
              Kargolarınızı takip edin, teklif alın ve tüm lojistik süreçlerinizi yönetin.
            </p>
          </div>

          {/* Bottom stats */}
          <div className="relative z-10 flex gap-8 px-10 pb-10 pt-6" style={{ borderTop: '1px solid rgba(255,255,255,0.1)' }}>
            {[
              { n: '200+', l: 'Ülke' },
              { n: '8.4K+', l: 'Aylık Gönderi' },
              { n: '7/24', l: 'Destek' },
            ].map((s) => (
              <div key={s.n}>
                <div style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 22, color: '#fff', lineHeight: 1 }}>{s.n}</div>
                <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.4)', marginTop: 3, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em' }}>{s.l}</div>
              </div>
            ))}
          </div>
        </div>

        {/* ── RIGHT PANEL — Form ── */}
        <div
          className="flex flex-col justify-center p-8 md:p-10"
          style={{ background: 'var(--bg2)', borderLeft: '1px solid rgba(255,255,255,0.06)' }}
        >
          {/* Mobile logo */}
          <div className="md:hidden mb-8 flex justify-center">
            <Link to="/" className="cursor-pointer">
              <img src={LOGO} alt="CargoNet" className={`h-8 w-auto object-contain ${isDark ? 'brightness-0 invert' : ''}`} />
            </Link>
          </div>

          {/* Heading */}
          <div className="mb-8">
            <h1 style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 30, color: 'var(--text1)', marginBottom: 8, lineHeight: 1.1 }}>
              Hoş Geldiniz
            </h1>
            <p style={{ fontSize: 14, color: 'var(--text2)', lineHeight: 1.65 }}>
              CargoNet hesabınıza giriş yapın.
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-5">
            {/* Username */}
            <div>
              <label style={{ display: 'block', fontSize: 11, fontWeight: 700, color: 'var(--text3)', letterSpacing: '0.07em', textTransform: 'uppercase', marginBottom: 8 }}>
                Kullanıcı Adı
              </label>
              <div className="relative">
                <div className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                  <i className="ri-user-3-line" style={{ color: 'var(--text3)', fontSize: 15 }} />
                </div>
                <input
                  type="text" name="username" placeholder="Kullanıcı adınız"
                  value={form.username}
                  onChange={(e) => setForm({ ...form, username: e.target.value })}
                  className="inp" style={{ paddingLeft: 40 }}
                  autoComplete="username"
                />
              </div>
            </div>

            {/* Password */}
            <div>
              <div className="flex items-center justify-between mb-2">
                <label style={{ fontSize: 11, fontWeight: 700, color: 'var(--text3)', letterSpacing: '0.07em', textTransform: 'uppercase' }}>
                  Şifre
                </label>
                <button type="button" className="cursor-pointer" style={{ fontSize: 12, fontWeight: 600, color: 'var(--orange)', background: 'none', border: 'none' }}>
                  Şifremi Unuttum
                </button>
              </div>
              <div className="relative">
                <div className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                  <i className="ri-lock-2-line" style={{ color: 'var(--text3)', fontSize: 15 }} />
                </div>
                <input
                  type={showPass ? 'text' : 'password'} name="password" placeholder="Şifreniz"
                  value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                  className="inp" style={{ paddingLeft: 40, paddingRight: 44 }}
                  autoComplete="current-password"
                />
                <button
                  type="button" onClick={() => setShowPass((v) => !v)}
                  className="absolute right-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center cursor-pointer"
                  style={{ background: 'none', border: 'none', color: 'var(--text3)' }}
                >
                  <i className={showPass ? 'ri-eye-off-line' : 'ri-eye-line'} style={{ fontSize: 16 }} />
                </button>
              </div>
            </div>

            {/* Remember */}
            <div className="flex items-center gap-3">
              <button
                type="button" onClick={() => setRemember((v) => !v)}
                className="flex-shrink-0 w-5 h-5 rounded flex items-center justify-center cursor-pointer transition-all duration-200"
                style={{ background: remember ? 'var(--orange)' : 'var(--surface)', border: `1.5px solid ${remember ? 'var(--orange)' : 'var(--border2)'}` }}
              >
                {remember && <i className="ri-check-line text-white" style={{ fontSize: 11 }} />}
              </button>
              <span className="cursor-pointer select-none" style={{ fontSize: 13, color: 'var(--text2)', fontWeight: 500 }} onClick={() => setRemember((v) => !v)}>
                Beni Hatırla
              </span>
            </div>

            {/* Error */}
            {error && (
              <div className="flex items-center gap-2 px-4 py-3 rounded-xl" style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.22)' }}>
                <i className="ri-error-warning-line" style={{ color: '#f87171', fontSize: 15 }} />
                <span style={{ fontSize: 13, color: '#f87171', fontWeight: 500 }}>{error}</span>
              </div>
            )}

            {/* Submit */}
            <button
              type="submit" disabled={loading}
              className="btn-primary w-full justify-center cursor-pointer"
              style={{ borderRadius: 12, fontSize: 15, opacity: loading ? 0.8 : 1 }}
            >
              {loading ? (
                <><i className="ri-loader-4-line" style={{ animation: 'spin 0.8s linear infinite' }} /> Giriş yapılıyor...</>
              ) : (
                <>Giriş Yap <i className="ri-arrow-right-line bounce-x" /></>
              )}
            </button>
          </form>

          {/* Divider */}
          <div className="flex items-center gap-4 my-6">
            <div className="flex-1 h-px" style={{ background: 'var(--border)' }} />
            <span style={{ fontSize: 11, color: 'var(--text3)', fontWeight: 600 }}>veya</span>
            <div className="flex-1 h-px" style={{ background: 'var(--border)' }} />
          </div>

          {/* Register */}
          <div className="text-center mb-4">
            <span style={{ fontSize: 14, color: 'var(--text2)' }}>Hesabınız yok mu? </span>
            <Link to="/uye-ol" className="cursor-pointer font-bold" style={{ fontSize: 14, color: 'var(--orange)', textDecoration: 'none' }}>
              Üye Ol
            </Link>
          </div>

          {/* Back */}
          <div className="text-center">
            <Link
              to="/"
              className="inline-flex items-center gap-1.5 cursor-pointer"
              style={{ fontSize: 13, color: 'var(--text3)', textDecoration: 'none', fontWeight: 500 }}
              onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--text2)')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--text3)')}
            >
              <i className="ri-arrow-left-line" style={{ fontSize: 13 }} />
              Ana Sayfaya Dön
            </Link>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        @keyframes gridpan {
          from { transform: perspective(500px) rotateX(60deg) translateY(0); }
          to   { transform: perspective(500px) rotateX(60deg) translateY(44px); }
        }
        @keyframes dashflow {
          from { stroke-dashoffset: 0; }
          to   { stroke-dashoffset: -28; }
        }
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.4; }
        }
        @media (max-width: 768px) {
          .login-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </div>
  );
}
